import ServiceNewIcon from '@/assets/icons/service-new-icon.svg?react';
import ServiceFailedIcon from '@/assets/icons/service-failed-icon.svg?react';
import ServiceProgressIcon from '@/assets/icons/service-progress-icon.svg?react';
import PayoutCashIcon from '@/assets/icons/payout-cash-icon.svg?react';
import PayoutCouponIcon from '@/assets/icons/payout-coupon-icon.svg?react';
import PayoutPointsIcon from '@/assets/icons/payout-points-icon.svg?react';
import PayoutPriceDownIcon from '@/assets/icons/payout-price-down-icon.svg?react';
import PayoutCashPointsIcon from '@/assets/icons/payout-cash-points-icon.svg?react';
import PayoutBottleInfoIcon from '@/assets/icons/payout-bottle-info-icon.svg?react';
import PayoutCardIcon from '@/assets/icons/payout-card-icon.svg?react';
import ActiveIcon from '@/assets/icons/active-icon.svg?react';
import ErrorIcon from '@/assets/icons/error-icon.svg?react';
import { bagStatuses } from '@/constants/Bag.jsx';
import { operatorChoices } from '@/constants/Operators.js';

export { operatorChoices };

export const countryChoices = translate => [{ id: 'Polska', name: translate('selectOptions.countries.polska') }];
export const provinceChoices = translate => [
    { id: 'dolnośląskie', name: translate('selectOptions.voivodeships.dolnośląskie') },
    { id: 'kujawsko-pomorskie', name: translate('selectOptions.voivodeships.kujawskoPomorskie') },
    { id: 'lubelskie', name: translate('selectOptions.voivodeships.lubelskie') },
    { id: 'lubuskie', name: translate('selectOptions.voivodeships.lubuskie') },
    { id: 'łódzkie', name: translate('selectOptions.voivodeships.łódzkie') },
    { id: 'małopolskie', name: translate('selectOptions.voivodeships.małopolskie') },
    { id: 'mazowieckie', name: translate('selectOptions.voivodeships.mazowieckie') },
    { id: 'opolskie', name: translate('selectOptions.voivodeships.opolskie') },
    { id: 'podkarpackie', name: translate('selectOptions.voivodeships.podkarpackie') },
    { id: 'podlaskie', name: translate('selectOptions.voivodeships.podlaskie') },
    { id: 'pomorskie', name: translate('selectOptions.voivodeships.pomorskie') },
    { id: 'śląskie', name: translate('selectOptions.voivodeships.śląskie') },
    { id: 'świętokrzyskie', name: translate('selectOptions.voivodeships.świętokrzyskie') },
    { id: 'warmińsko-mazurskie', name: translate('selectOptions.voivodeships.warmińskoMazurskie') },
    { id: 'wielkopolskie', name: translate('selectOptions.voivodeships.wielkopolskie') },
    { id: 'zachodniopomorskie', name: translate('selectOptions.voivodeships.zachodniopomorskie') },
];
export const posTypeChoices = [];

export const allOperatorFilterChoices = translate => [...operatorChoices, { id: 'null', name: translate('common.noOperator') }];

export const couponChoices = [
    { id: 'comp', name: 'Comp' },
    { id: 'zwrotka', name: 'Zwrotka' },
    { id: 'eurocash', name: 'Eurocash' },
    { id: 'maasloop', name: 'Maasloop' },
];

export const operatorCouponChoices = [{ id: 'kaucja', name: 'Kaucja' }];

export const allCouponsFilterChoices = translate => [...couponChoices, ...operatorCouponChoices, { id: 'null', name: translate('common.noCouponSource') }];

export const forwarderTypeChoices = translate => [
    { id: 'Default', name: translate('common.empty') },
    { id: 'Żabka', name: 'Żabka' },
    { id: 'Lewiatan', name: 'Lewiatan' },
    { id: 'Eurocash', name: 'Eurocash' },
];
export const errorLevelChoices = [
    { id: 1, name: 'critical', color: '#FF615E' },
    { id: 2, name: 'error', color: '#f1a139' },
    { id: 3, name: 'warning', color: '#FFDF7B' },
    { id: 4, name: 'info', color: '#91C3FF' },
    { id: 5, name: 'verbose', color: '#D8D8D8' },
];

export const errorTypeChoices = translate => [
    { id: 'softwareFailure', name: translate('selectOptions.errorTypeChoices.softwareFailure') },
    { id: 'mechanicalFailure', name: translate('selectOptions.errorTypeChoices.mechanicalFailure') },
    { id: 'vandalismAct', name: translate('selectOptions.errorTypeChoices.vandalismAct') },
    { id: 'productionDefect', name: translate('selectOptions.errorTypeChoices.productionDefect') },
    { id: 'irrelevantRequest', name: translate('selectOptions.errorTypeChoices.irrelevantRequest') },
];

export const deviceStateChoices = [
    { id: 'online', name: 'Online' },
    { id: 'outOfService', name: 'Out of service' },
    { id: 'permanentError', name: 'Permanent error' },
    { id: 'binFull', name: 'Bin full' },
    { id: 'offline', name: 'Offline' },
    { id: 'codeError', name: 'Code error' },
];

export const serviceRequestPriorityChoices = translate => [
    { id: 'low', name: translate('common.priority.low'), color: '#DDC2FB', outlineColor: '#C697FA' },
    { id: 'normal', name: translate('common.priority.normal'), color: '#BCD9FF', outlineColor: '#91C3FF' },
    { id: 'high', name: translate('common.priority.high'), color: '#FFD2D8', outlineColor: '#F8A2A3' },
];

export const serviceRequestTypeChoices = translate => [
    { id: 'softwareFailure', name: translate('selectOptions.errorTypeChoices.softwareFailure'), color: '#DDC2FB', outlineColor: '#C697FA' },
    { id: 'mechanicalFailure', name: translate('selectOptions.errorTypeChoices.mechanicalFailure'), color: '#FFD2D8', outlineColor: '#F8A2A3' },
    { id: 'vandalismAct', name: translate('selectOptions.errorTypeChoices.vandalismAct'), color: '#FFDF7B', outlineColor: '#FFD342' },
    { id: 'productionDefect', name: translate('selectOptions.errorTypeChoices.productionDefect'), color: '#FFD2D8', outlineColor: '#F8A2A3' },
    { id: 'irrelevantRequest', name: translate('selectOptions.errorTypeChoices.irrelevantRequest'), color: '#E8E8E8', outlineColor: '#D8D8D8' },
];

export const serviceRequestStatusChoices = translate => [
    { id: 'new', name: translate('selectOptions.serviceRequestStatusChoices.new'), serviceRegularDisabled: true, icon: <ServiceNewIcon /> },
    {
        id: 'failedContact',
        name: translate('selectOptions.serviceRequestStatusChoices.failedContact'),
        serviceRegularDisabled: true,
        icon: <ServiceFailedIcon />,
    },
    { id: 'accepted', name: translate('analytics.service.status.accepted'), serviceRegularDisabled: true, icon: <ServiceProgressIcon /> },
    { id: 'pending', name: translate('analytics.service.status.pending'), serviceRegularDisabled: true, icon: <ServiceProgressIcon /> },
    { id: 'inProgress', name: translate('analytics.service.status.inProgress'), serviceRegularDisabled: false, icon: <ServiceProgressIcon /> },
    { id: 'fixed', name: translate('analytics.service.status.fixed'), serviceRegularDisabled: false, icon: <ServiceProgressIcon /> },
    { id: 'closed', name: translate('selectOptions.serviceRequestStatusChoices.closed'), serviceRegularDisabled: true, icon: <ServiceProgressIcon /> },
];

export const deviceServiceStatusChoices = translate => [
    { id: 'waitingForTriage', name: translate('selectOptions.serviceRequestStatusChoices.waitingForTriage') },
    { id: 'serviceInspection', name: translate('selectOptions.errorTypeChoices.serviceInspection') },
    { id: 'new', name: translate('selectOptions.serviceRequestStatusChoices.new') },
    { id: 'failedContact', name: translate('selectOptions.serviceRequestStatusChoices.failedContact') },
    { id: 'accepted', name: translate('analytics.service.status.accepted') },
    { id: 'pending', name: translate('analytics.service.status.pending') },
    { id: 'inProgress', name: translate('analytics.service.status.inProgress') },
    { id: 'fixed', name: translate('analytics.service.status.fixed') },
    { id: 'closed', name: translate('selectOptions.serviceRequestStatusChoices.closed') },
    { id: 'ok', name: translate('selectOptions.serviceRequestStatusChoices.ok') },
];

export const serviceRequestSourceTypeChoices = translate => [
    { id: 'collection_point', name: translate('selectOptions.serviceRequestSourceTypeChoices.collectionPoint') },
    { id: 'user', name: translate('selectOptions.serviceRequestSourceTypeChoices.user') },
    { id: 'auto', name: translate('selectOptions.serviceRequestSourceTypeChoices.auto') },
];

export const notificationChannelChoices = (translate, summaryFrequency) => {
    const hoursMap = {
        daily: 24,
        hourly: 1,
    };
    const hours = hoursMap[summaryFrequency] || null;
    const summaryTranslation = hours
        ? translate('selectOptions.notificationChannelChoices.email_summary_hours', { hours })
        : translate('selectOptions.notificationChannelChoices.email_summary');

    return [
        { id: 'app', name: translate('selectOptions.notificationChannelChoices.app') },
        { id: 'email', name: translate('selectOptions.notificationChannelChoices.email') },
        { id: 'sms', name: translate('selectOptions.notificationChannelChoices.sms') },
        { id: 'email_summary', name: summaryTranslation },
    ];
};

export const depositWithdrawalMethodsChoices = translate => [
    { id: 'cash', name: translate('selectOptions.depositWithdrawalMethodsChoices.cash'), icon: <PayoutCashIcon /> },
    { id: 'loyaltyPoints', name: translate('selectOptions.depositWithdrawalMethodsChoices.loyaltyPoints'), icon: <PayoutPointsIcon /> },
    { id: 'discount', name: translate('selectOptions.depositWithdrawalMethodsChoices.discount'), icon: <PayoutCouponIcon /> },
    { id: 'pointsAndDiscount', name: translate('selectOptions.depositWithdrawalMethodsChoices.pointsAndDiscount'), icon: <PayoutCouponIcon /> },
    { id: 'cashDiscount', name: translate('selectOptions.depositWithdrawalMethodsChoices.cashDiscount'), icon: <PayoutPriceDownIcon /> },
    { id: 'campaign', name: translate('selectOptions.depositWithdrawalMethodsChoices.campaign'), icon: <PayoutCouponIcon /> },
    { id: 'cashAndPoints', name: translate('selectOptions.depositWithdrawalMethodsChoices.cashAndPoints'), icon: <PayoutCashPointsIcon /> },
    { id: 'card', name: translate('selectOptions.depositWithdrawalMethodsChoices.card'), icon: <PayoutCardIcon /> },
];

export const transactionPayoutChoices = translate => [
    ...depositWithdrawalMethodsChoices(translate),
    { id: 'bottleInfo', name: 'Potwierdzenie', icon: <PayoutBottleInfoIcon /> },
];

export const operatorStatusChoices = translate => [
    { id: 'added', name: translate('selectOptions.operatorStatusChoices.added'), icon: null },
    { id: 'sent', name: translate('selectOptions.operatorStatusChoices.sent'), icon: <ActiveIcon /> },
    { id: 'error', name: translate('selectOptions.operatorStatusChoices.error'), icon: <ErrorIcon /> },
    { id: 'no_operator', name: translate('selectOptions.operatorStatusChoices.noOperator'), icon: null },
    { id: 'not_sent', name: translate('selectOptions.operatorStatusChoices.notSent'), icon: null },
];

export const transactionStatusChoices = translate => [
    { id: 0, name: translate('selectOptions.operatorStatusChoices.added'), icon: null },
    { id: 1, name: translate('selectOptions.operatorStatusChoices.sent'), icon: <ActiveIcon /> },
    { id: 2, name: translate('selectOptions.operatorStatusChoices.error'), icon: <ErrorIcon /> },
    { id: 3, name: translate('selectOptions.operatorStatusChoices.notSent'), icon: null },
];

export const bagStatusChoices = translate => [
    { id: bagStatuses.collected, name: translate('resources.bag.labels.closedBag') },
    { id: bagStatuses.in_progress, name: translate('resources.bag.labels.fillingInProgress') },
    { id: bagStatuses.manually_closed, name: translate('resources.bag.labels.manuallyClosed') },
    { id: bagStatuses.error, name: translate('resources.bag.labels.error') },
];

export const rankingTypeChoices = translate => [
    { id: 'mostPopular', name: translate('selectOptions.rankingTypeChoices.mostPopular') },
    { id: 'trending', name: translate('selectOptions.rankingTypeChoices.trending') },
    { id: 'losing', name: translate('selectOptions.rankingTypeChoices.losing') },
];

export const serviceRankingTypeChoices = translate => [
    { id: 'provinces', name: translate('selectOptions.serviceRankingTypeChoices.provinces') },
    { id: 'contractors', name: translate('selectOptions.serviceRankingTypeChoices.contractors') },
];

export const operatorFilterChoices = translate => [
    { id: 'Zwrotka', name: 'Zwrotka' },
    { id: 'ZwrotkaTest', name: 'Zwrotka Test' },
    { id: 'Kaucja', name: 'Kaucja' },
    { id: 'PSK', name: 'PSK' },
    { id: 'Reselekt', name: 'Reselekt' },
    { id: 'null', name: translate('common.shortage') },
];

export const productStatusChoices = translate => [
    { id: 0, name: translate('selectOptions.productStatusChoices.unverified') },
    { id: 1, name: translate('selectOptions.productStatusChoices.accepted') },
    { id: 2, name: translate('selectOptions.productStatusChoices.rejected') },
    { id: 3, name: translate('selectOptions.productStatusChoices.withdrawn') },
    { id: 4, name: translate('selectOptions.productStatusChoices.noDeposit') },
];

export const boolChoices = translate => [
    { id: 1, name: translate('common.boolean.yes') },
    { id: 0, name: translate('common.boolean.no') },
];

export const productColorChoices = translate => [
    { id: 'czysty', name: translate('common.colors.clean') },
    { id: 'niebieski', name: translate('common.colors.blue') },
    { id: 'żółty', name: translate('common.colors.yellow') },
    { id: 'zielony', name: translate('common.colors.green') },
    { id: 'fioletowy', name: translate('common.colors.purple') },
    { id: 'czerwony', name: translate('common.colors.red') },
    { id: 'brązowy', name: translate('common.colors.brown') },
    { id: 'szary', name: translate('common.colors.gray') },
    { id: 'czarny', name: translate('common.colors.black') },
    { id: 'inny', name: translate('common.colors.other') },
];

export const languageChoices = translate => [
    { id: 'pl', name: translate('selectOptions.languageChoices.polish') },
    { id: 'en', name: translate('selectOptions.languageChoices.english') },
];

export const softwareTypeChoices = [
    { id: 'MCU', name: 'MCU' },
    { id: 'SOC', name: 'SOC' },
];

export const deploymentStatusShortChoices = translate => [
    { id: 'new', name: translate('selectOptions.deploymentStatusShortChoices.new') },
    { id: 'productionDone', name: translate('selectOptions.deploymentStatusShortChoices.productionDone') },
    { id: 'readyForDeployment', name: translate('selectOptions.deploymentStatusShortChoices.readyForDeployment') },
    { id: 'deployed', name: translate('selectOptions.deploymentStatusShortChoices.deployed') },
];

export const accessKeyStatusChoices = translate => [
    { id: 'active', name: translate('selectOptions.accessKeyStatusChoices.active') },
    { id: 'revoked', name: translate('selectOptions.accessKeyStatusChoices.revoked') },
    { id: 'rotation_pending', name: translate('selectOptions.accessKeyStatusChoices.rotationPending') },
];

export const collectionTypeChoices = translate => [
    { id: 'manual', name: translate('resources.device.choices.collectionType.manual') },
    { id: 'automatic', name: translate('resources.device.choices.collectionType.automatic') },
];

export const reportFrequencyChoices = translate => [
    { id: 'off', name: translate('selectOptions.reportFrequencyChoices.off') },
    { id: 'weekly', name: translate('selectOptions.reportFrequencyChoices.weekly') },
    { id: 'biweekly', name: translate('selectOptions.reportFrequencyChoices.biweekly') },
    { id: 'monthly', name: translate('selectOptions.reportFrequencyChoices.monthly') },
];

export const billOfMaterialsStatusChoices = translate => [
    { id: 'inUse', name: translate('selectOptions.billOfMaterialsStatusChoices.inUse') },
    { id: 'archived', name: translate('selectOptions.billOfMaterialsStatusChoices.archived') },
];
